import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function LocalParkingIcon(props: IconProps) {
    return <Icon {...props} iconKey={"local_parking"}/>
}
